import colors from 'theme/colors';
import { StationIconProps } from './types';

export const Decision = ({ background = colors.darkBlue, color = colors.white, ...rest }: StationIconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="8" cy="8" r="8" fill={background} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.27778 12.5C6.55392 12.5 6.77778 12.2761 6.77778 12V8.13022C6.77778 7.85408 6.55392 7.63022 6.27778 7.63022C6.00164 7.63022 5.77778 7.85408 5.77778 8.13022V12C5.77778 12.2761 6.00164 12.5 6.27778 12.5Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.92422 12.3536C6.11949 12.5488 6.43607 12.5488 6.63133 12.3536L8.40911 10.5758C8.60437 10.3805 8.60437 10.0639 8.40911 9.86867C8.21385 9.67341 7.89726 9.67341 7.702 9.86867L6.27778 11.2929L4.85355 9.86867C4.65829 9.67341 4.34171 9.67341 4.14645 9.86867C3.95118 10.0639 3.95118 10.3805 4.14645 10.5758L5.92422 12.3536Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3687 11.0202C10.5639 11.2155 10.8805 11.2155 11.0758 11.0202L12.8536 9.24244C13.0488 9.04718 13.0488 8.7306 12.8536 8.53534L11.0758 6.75756C10.8805 6.5623 10.5639 6.5623 10.3687 6.75756C10.1734 6.95282 10.1734 7.2694 10.3687 7.46466L11.7929 8.88889L10.3687 10.3131C10.1734 10.5084 10.1734 10.825 10.3687 11.0202Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1667 8.38889C10.0027 8.38889 8.88633 7.92649 8.06325 7.10341C7.24018 6.28034 6.77778 5.16401 6.77778 4C6.77778 3.72386 6.55392 3.5 6.27778 3.5C6.00164 3.5 5.77778 3.72386 5.77778 4C5.77778 5.42922 6.34553 6.79991 7.35615 7.81052C8.36676 8.82113 9.73744 9.38889 11.1667 9.38889H12.5C12.7761 9.38889 13 9.16503 13 8.88889C13 8.61275 12.7761 8.38889 12.5 8.38889H11.1667Z"
                fill={color}
            />
        </svg>
    );
};
